import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LIST_SERVER_PAGINATION_INITIAL_STATE } from '../../../../../../common/models/list.model';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { NotificationService, ListServerPaginationStateModel } from '../../../../../../common';
import { DeliveryNoteHandlingUnitModel } from '../../../models';
import { DeliveryNoteHandlingUnits } from './delivery-note-handling-units.actions';
import { DeliveryNoteHandlingUnitsService } from './delivery-note-handling-units.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type DeliveryNoteHandlingUnitsStateModel = ListServerPaginationStateModel<DeliveryNoteHandlingUnitModel>;

const initialState: DeliveryNoteHandlingUnitsStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<DeliveryNoteHandlingUnitsStateModel>({
  name: 'deliveryNoteHandlingList',
  defaults: initialState,
})
@Injectable()
export class DeliveryNoteHandlingUnitsState {
  constructor(
    private deliveryNoteHandlingUnitsService: DeliveryNoteHandlingUnitsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: DeliveryNoteHandlingUnitsStateModel): DeliveryNoteHandlingUnitsStateModel {
    return state;
  }

  @Selector()
  static getItems(state: DeliveryNoteHandlingUnitsStateModel): DeliveryNoteHandlingUnitModel[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: DeliveryNoteHandlingUnitsStateModel): boolean {
    return state.loaded;
  }

  @Action(DeliveryNoteHandlingUnits)
  getDeliveryNoteHandlingUnits(
    ctx: StateContext<DeliveryNoteHandlingUnitsStateModel>,
    { payload }: DeliveryNoteHandlingUnits,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.deliveryNoteHandlingUnitsService
      .getHandlingUnits(payload.deliveryNoteParams, payload.searchCriteria)
      .pipe(
        take(1),
        map((handlingUnits: DeliveryNoteHandlingUnitsStateModel) => {
          ctx.patchState({ ...handlingUnits, loaded: true });
        }),
        catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
      );
  }
}
